export default __webpack_public_path__ + "static/media/WiredMono-Bold.7350d8bd.otf";